export enum AddressFormType {
  BILLING = 'billing',
  BILLING_NEW_SAVED = 'billing_newSavedAddress',
  NEW_SAVED = 'newSavedAddress',
  SHIPPING = 'shipping',
  SHIPPING_NEW_SAVED = 'shipping_newSavedAddress',
}
